import React, { useState } from 'react'
import { WidgetContent, TextField, Select } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import { Checkbox, Tabs, TabItem } from '@duik/it'
import moment from 'moment'

const ReplaceTruck = ({ truckDetail, drivers, handleReplaceTruckModalClose, replaceDriver }) => {
  const [selectedDriver, setSelectedDriver] = useState()

  const handleSaveButtonClick = () => {
    replaceDriver(truckDetail, [...selectedDriver])
    handleReplaceTruckModalClose(true)
  }

  const handleDriverSelect = driver => {
    setSelectedDriver(driver)
  }

  return (
    <CreateNewModal title="Replace Truck" handleCloseModal={handleReplaceTruckModalClose}>
      <form>
        <WidgetContent
          style={{
            height: '415px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 0,
            overflowY: 'scroll',
            overflowX: 'hidden'
          }}
          id="dispatch-form"
        >
          <div style={{ width: '100%' }}>
            <Tabs sm>
              <TabItem className="active">
                {moment(truckDetail.startDateTime).format('HH:mm')}
              </TabItem>
            </Tabs>
            <div style={{ padding: '0 30px' }}>
              <div
                style={{
                  marginTop: '16px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <span style={{ fontSize: '12px', color: '#9EA0A5' }}>
                  REPLACE (1) - {truckDetail.pickUpSite} to {truckDetail.dropOffSite}
                </span>
              </div>
              <div
                style={{
                  marginTop: '8px',
                  height: '59px',
                  border: '1px solid #D8DCE6',
                  borderRadius: '4px'
                }}
              >
                <table style={{ width: '100%', padding: '10px 16px' }}>
                  <tbody>
                    <tr style={{ height: '40px' }}>
                      <td>
                        <span>{truckDetail.driverName}</span>
                      </td>
                      <td>
                        <span>{truckDetail.truckType}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                style={{
                  marginTop: '16px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <span style={{ fontSize: '12px', color: '#9EA0A5' }}>
                  WITH ({selectedDriver ? '1' : '0'})
                </span>
              </div>
              <div
                style={{
                  marginTop: '8px',
                  height: '59px',
                  border: '1px solid #D8DCE6',
                  borderRadius: '4px'
                }}
              >
                <table style={{ width: '100%', padding: '10px 16px' }}>
                  <tbody>
                    <tr style={{ height: '40px' }}>
                      <td>
                        <span>
                          {selectedDriver
                            ? `${selectedDriver.firstName} ${selectedDriver.lastName}`
                            : ''}
                        </span>
                      </td>
                      <td>
                        <span>{selectedDriver ? selectedDriver.truckType : ''}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                style={{
                  paddingTop: '16px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <div style={{ width: '322px' }}>
                  <TextField
                    className="threeQuarterWidthInputBox materials optionsFullWidth"
                    label=""
                    name="driverSerach"
                    // onChange={handleChange}
                    // onBlur={handleBlur}
                    // value={values.driverSearch}
                    placeholder="Search for a driver"
                  />
                </div>
                <div style={{ width: '134px' }}>
                  <Select
                    style={{ width: '134px' }}
                    activeOption={[{ value: '', label: '' }]}
                    label=""
                    options={[{ value: 'All', label: 'All' }]}
                    name="driverFilter"
                    menuPosition="bottom-left"
                    onOptionClick={e => console.log(e)}
                    placeholder="All"
                  />
                </div>
              </div>

              <div
                style={{
                  marginTop: '16px',
                  height: '200px',
                  overflowY: 'scroll',
                  border: '1px solid #D8DCE6',
                  borderRadius: '4px'
                }}
              >
                <table style={{ width: '100%', padding: '10px 16px' }}>
                  <tbody>
                    {drivers.map((item, i) => (
                      <tr style={{ height: '40px' }} key={i}>
                        <td>
                          <Checkbox
                            onChange={() => handleDriverSelect(item)}
                            style={{ color: '#34AA44' }}
                            checked={selectedDriver ? selectedDriver._id === item._id : undefined}
                          />
                        </td>
                        <td>
                          <span>
                            {item.firstName} {item.lastName}
                          </span>
                        </td>
                        <td>
                          <span>{item.truckType}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </WidgetContent>
        <div style={{ display: 'flex' }}>
          <WidgetContent
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              border: 'none',
              width: '482px'
            }}
          >
            <div style={{ width: '83px' }}>
              <ModalButton
                buttonStyle="tertiary"
                name="Cancel"
                onClick={handleReplaceTruckModalClose}
              />
            </div>
            <div style={{ width: '83px' }}>
              <ModalButton
                success
                // disabled={isSubmitting}
                name="Save"
                onClick={handleSaveButtonClick}
              />
            </div>
          </WidgetContent>
        </div>
      </form>
    </CreateNewModal>
  )
}

export default ReplaceTruck
